export function moneyFormat(amount: number) {
  const amountToFormat = isNaN(amount) ? 0 : amount;

  return amountToFormat.toLocaleString('en-US', {
    currency: 'USD',
    currencyDisplay: 'symbol',
    style: 'currency',
  });
}
